import { Injectable } from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class VnaCallerIdService {

    constructor(private api: ApiService) { }

    findCallerIds(criteria?: Object): Observable<any> {
        return this.api.get('vna/caller-id', criteria);
    }

    findCallerId(pk: number): Observable<any> {
        return this.api.get('vna/caller-id/' + pk);
    }

    getCallerIdsReport(startDate: string, endDate: string): Observable<any> {
        return this.api.get('vna/caller-id/report', {'start_date' : startDate, 'end_date' : endDate});
    }

    createCallerId(body: Object): Observable<any> {
        return this.api.post('vna/caller-id', body);
    }

    updateCallerId(pk: number, body: Object): Observable<any> {
        return this.api.customPut('vna/caller-id/' + pk, body);
    }

    patchCallerId(pk: number, partialBody: Object): Observable<any> {
        return this.api.customPatch('vna/caller-id/' + pk, partialBody)
    }

    deleteCallerId(pk: number): Observable<any> {
        return this.api.remove('vna/caller-id', pk);
    }

    callerIdToCampaigns(pk: number, pkPortal: number, pkCamps: Array<number>): Observable<any> {
        return this.api.customPatch('vna/caller-id/' + pk + '/campaign', {'pks_camps' : pkCamps, 'portal_pk' : pkPortal });
    }

    getCallerIdsVerifications(criteria?: Object): Observable<any> {
      return this.api.get('vna/caller-id-verification', criteria);
    }

    getCallerIdCampaigns(callerId: string): Observable<any> {
      return this.api.get('vna/caller-id-verification/caller-id-campaign', { clid: callerId});
    }

    getSendCallerIdsToVerify(criteria?: Object): Observable<any> {
      return this.api.get('vna/caller-id/verifications-send', criteria);
    }

    getSendCallerIdToVerify(callerId: string): Observable<any> {
      return this.api.get('vna/caller-id/verification-send', {number: callerId});
    }

    postCallerIdsFile(data: FormData): Observable<any> {
      return this.api.post('vna/caller-ids', data);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/caller-id/services/vna-caller-id.service.ts